import { gql, useQuery } from '@apollo/client';

// ── GraphQL Documents ────────────────────────────────────────────

const CHART_CATEGORY_SPEND = gql`
  query ChartCategorySpend($dateFrom: Date, $dateTo: Date, $categoryIds: [Int]) {
    chartCategorySpend(dateFrom: $dateFrom, dateTo: $dateTo, categoryIds: $categoryIds) {
      category
      color
      total
    }
  }
`;

const CHART_CUMULATIVE_SPEND = gql`
  query ChartCumulativeSpend($dateFrom: Date, $dateTo: Date, $categoryIds: [Int]) {
    chartCumulativeSpend(dateFrom: $dateFrom, dateTo: $dateTo, categoryIds: $categoryIds) {
      keys
      colors
      rows {
        date
        jsonValues
      }
    }
  }
`;

const CHART_AMOUNT_RANGE = gql`
  query ChartAmountRange($dateFrom: Date, $dateTo: Date, $categoryIds: [Int]) {
    chartAmountRange(dateFrom: $dateFrom, dateTo: $dateTo, categoryIds: $categoryIds) {
      bucket
      count
      total
    }
  }
`;

const CHART_P2P_VS_COMMERCE = gql`
  query ChartP2pVsCommerce($dateFrom: Date, $dateTo: Date, $categoryIds: [Int]) {
    chartP2pVsCommerce(dateFrom: $dateFrom, dateTo: $dateTo, categoryIds: $categoryIds) {
      id
      label
      value
    }
  }
`;

const CHART_CREDIT_DEBIT_MONTHLY = gql`
  query ChartCreditDebitMonthly($dateFrom: Date, $dateTo: Date, $categoryIds: [Int]) {
    chartCreditDebitMonthly(dateFrom: $dateFrom, dateTo: $dateTo, categoryIds: $categoryIds) {
      month
      credit
      debit
    }
  }
`;

// ── Helper ───────────────────────────────────────────────────────

function buildVars(dateFrom, dateTo, categoryIds) {
  return {
    ...(dateFrom ? { dateFrom: dateFrom.format('YYYY-MM-DD') } : {}),
    ...(dateTo   ? { dateTo:   dateTo.format('YYYY-MM-DD')   } : {}),
    ...(categoryIds ? { categoryIds } : {}),
  };
}

// ── Hooks ────────────────────────────────────────────────────────

export function useChartCategorySpend({ dateFrom, dateTo, categoryIds }) {
  return useQuery(CHART_CATEGORY_SPEND, {
    variables: buildVars(dateFrom, dateTo, categoryIds),
    fetchPolicy: 'cache-and-network',
  });
}

export function useChartCumulativeSpend({ dateFrom, dateTo, categoryIds }) {
  return useQuery(CHART_CUMULATIVE_SPEND, {
    variables: buildVars(dateFrom, dateTo, categoryIds),
    fetchPolicy: 'cache-and-network',
  });
}

export function useChartAmountRange({ dateFrom, dateTo, categoryIds }) {
  return useQuery(CHART_AMOUNT_RANGE, {
    variables: buildVars(dateFrom, dateTo, categoryIds),
    fetchPolicy: 'cache-and-network',
  });
}

export function useChartP2pVsCommerce({ dateFrom, dateTo, categoryIds }) {
  return useQuery(CHART_P2P_VS_COMMERCE, {
    variables: buildVars(dateFrom, dateTo, categoryIds),
    fetchPolicy: 'cache-and-network',
  });
}

export function useChartCreditDebitMonthly({ dateFrom, dateTo, categoryIds }) {
  return useQuery(CHART_CREDIT_DEBIT_MONTHLY, {
    variables: buildVars(dateFrom, dateTo, categoryIds),
    fetchPolicy: 'cache-and-network',
  });
}
